import { ProjectDetails } from '../pages';
import { IPage } from '../pages/types';
import { WithRouteData } from '../render-routes';

export const ProjectPage = (props: IPage) => <ProjectDetails {...props} />;

export default WithRouteData(ProjectPage);
